"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeocoderService = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../i18n");
var index_1 = require("./index");
/**
 * https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
 */
var ADDRESS_TYPES = {
    CITY: 'locality',
    STATE: 'administrative_area_level_1'
};
var GeocoderService = /** @class */ (function () {
    function GeocoderService() {
        this.__priority = 100;
        this.isReady = false;
    }
    GeocoderService.prototype.init = function () {
        var _this = this;
        this.isReadyPromise = new Promise(function (resolve) {
            var waitForGoogleGeocoder = index_1.Services.Window.window.setInterval(function () {
                if (typeof google === 'undefined') {
                    return;
                }
                index_1.Services.Window.window.clearTimeout(waitForGoogleGeocoder);
                _this.setIsReady();
                resolve();
            }, 10);
        });
    };
    GeocoderService.prototype.setIsReady = function () {
        this.isReady = true;
    };
    GeocoderService.prototype.getLatLng = function (location) {
        var latLng = new google.maps.LatLng(location.coordinates[1], location.coordinates[0]);
        return latLng;
    };
    GeocoderService.prototype.getGeocoderRequest = function (location) {
        var geocoderRequest = {
            location: location,
            language: 'en'
        };
        return geocoderRequest;
    };
    GeocoderService.prototype.geocoderResult = function (location) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.geocoder == null) {
                _this.geocoder = new google.maps.Geocoder();
            }
            var latLng = _this.getLatLng(location);
            var geocoderRequest = _this.getGeocoderRequest(latLng);
            _this.geocoder.geocode((geocoderRequest), function (results, status) {
                if (status.toString() === 'OK') {
                    resolve(results[0]);
                }
                else {
                    reject(status);
                }
            });
        });
    };
    GeocoderService.prototype.getAddress = function (location) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, geoCoderResult, _i, _a, component, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isReady) {
                            throw new Error('Cannot fetch geocode before Google Maps API loaded');
                        }
                        result = {
                            address: null,
                            city: null,
                            state: null
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.geocoderResult(location)];
                    case 2:
                        geoCoderResult = _b.sent();
                        index_1.Services.Log.Logger.info(geoCoderResult.formatted_address);
                        result.address = geoCoderResult.formatted_address;
                        for (_i = 0, _a = geoCoderResult.address_components; _i < _a.length; _i++) {
                            component = _a[_i];
                            if (component.types.indexOf(ADDRESS_TYPES.CITY) > -1) {
                                result.city = component.long_name;
                            }
                            if (component.types.indexOf(ADDRESS_TYPES.STATE) > -1) {
                                result.state = component.long_name;
                            }
                        }
                        return [2 /*return*/, result];
                    case 3:
                        err_1 = _b.sent();
                        index_1.Services.Log.Logger.error(err_1);
                        result.address = (0, i18n_1.Translate)(i18n_1.T.ERROR_GENERAL);
                        return [2 /*return*/, result];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], GeocoderService.prototype, "isReady", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], GeocoderService.prototype, "setIsReady", null);
    return GeocoderService;
}());
exports.GeocoderService = GeocoderService;
//# sourceMappingURL=geocoder.service.js.map